import React from 'react';
import BlogSmSingleColumn from '../../../components/BlogTwoSingleColumn/BlogSmSingleColumn';
import blog from '../../../fakeData/blogs/blogs';
import enBlog from '../../../fakeData/blogs/en-blogs';
import { useTranslation } from 'react-i18next';
import SEOHead from '../../../components/SEO/SEOHead';

const BlogTwoArea = () => {
    //Blog Kategori Sayfası
    const { t, i18n } = useTranslation();
    const featuredBlogImage = i18n.language === 'en' ? enBlog[0]?.image : blog[0]?.image;

    return (
        <>
            <section className="blog-area pt-50 pb-120">
                <div className="header-info position-absolute d-md-none flex" style={{ top: 65 }}>
                    <a href="tel:+903125574646"> <span><i className="fas fa-phone"></i> +90 312 557 46 46</span></a>
                    <a href="tel:+905332691271"> <span><i className="fas fa-phone"></i> +90 533 269 12 71</span></a>
                </div>
                <SEOHead
                    title={i18n.language === 'en' ? 'Assoc. Prof. Dr. Ebru Karagün | Blog' : 'Doç. Dr. Ebru Karagün | Blog'}
                    description={i18n.language === 'en'
                        ? 'Read blog articles on dermatology, aesthetic procedures, mesotherapy, fillers, lasers, and healthy skin care.'
                        : 'Dermatoloji, dolgu, mezoterapi, lazer uygulamaları ve sağlıklı cilt bakımı hakkında blog yazılarını keşfedin.'}
                    image={featuredBlogImage}
                    imageAlt={i18n.language === 'en'
                        ? 'Featured blog image from Assoc. Prof. Dr. Ebru Karagün articles'
                        : 'Doç. Dr. Ebru Karagün blog yazilarindan one cikan gorsel'}
                    trPath="/blogs"
                    enPath="/en/blogs"
                />
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7 col-lg-8 col-md-12">
                            <div className="section-title pos-rel mb-75">
                                <div className="section-icon">
                                    <img className="section-back-icon back-icon-left" src="/img/section/blog-background.png" width={480} style={{ opacity: 0.3 }} alt="" />
                                </div>
                                <div className="section-text pos-rel">
                                    <h2 className='sub-custom-header'>{t('blogsPage.subHeader')}</h2>
                                    <h1>{t('blogsPage.header')}</h1>
                                </div>
                                <div className="section-line pos-rel">
                                    <img src="/img/shape/section-title-line.png" alt="" />
                                </div>
                            </div>
                        </div>

                        {i18n.language === 'en' ?
                            enBlog.map((e, i) => {
                                return <BlogSmSingleColumn id={e.blogid} image={e.image} title={e.content?.blogPageTitle} decription={e.content?.blogPageDesc}
                                    date={e.date} />
                            }) :
                            blog.map((e, i) => {
                                return <BlogSmSingleColumn id={e.blogid} image={e.image} title={e.content?.blogPageTitle} decription={e.content?.blogPageDesc}
                                    date={e.date} />
                            })
                        }

                    </div>

                </div>
            </section>
        </>
    );
};

export default BlogTwoArea;
